// ** React Imports
import { Fragment } from 'react'

// ** Routes Imports
import ClosuresExecutive from './ClosuresExecutive'
import ClosuresManager from './ClosuresManager'
import ClosuresCharge from './ClosuresCharge'
import ClosuresPayment from './ClosuresPayment'
import Meetings from './Meetings'
import Uptakes from './Uptakes'
import Prospections from './Prospections'
import EquipmentsLoan from './EquipmentsLoan'
import Equipments from './Equipments'
import Calculator from './Calculator'
import Access from './Access'
import Comission from './Comission'
import Publications from './Publication'
import Attendance from './Attendance'
import Conversions from './Conversions'
import ConversionsUnitIndex from './ConversionsUnit'
import LoanKey from './LoanKey'
import Kpis from './Kpis'
import KpisConfig from './KpisConfig'
import Offices from './Offices'
import Feepayment from './Feepayments'
import ClosuresAll from './AllClosure'
import Results from './Results'
import ComissionMaster from './ComissionMaster'
import ComissionMasterUni from './ComissionMasterUni'
import UnifiedInvoice from './UnifiedInvoice'
import DashboardsCOC from './DashboardsCOC'
import DashboardsGlobal from './DashboardsGlobal'
import DashboardAsisstance from './DashboardAsisstance'

import AppRoutes from './Apps'
import FormRoutes from './Forms'
import PagesRoutes from './Pages'
import TablesRoutes from './Tables'
import ChartsRoutes from './Charts'
import DashboardRoutes from './Dashboards'
import UiElementRoutes from './UiElements'
import ExtensionsRoutes from './Extensions'
import PageLayoutsRoutes from './PageLayouts'
import AuthenticationRoutes from './Authentication'

// ** Layouts
import BlankLayout from '@layouts/BlankLayout'
import VerticalLayout from '@src/layouts/VerticalLayout'
import HorizontalLayout from '@src/layouts/HorizontalLayout'
import LayoutWrapper from '@src/@core/layouts/components/layout-wrapper'

// ** Route Components
import PublicRoute from '@components/routes/PublicRoute'
import PrivateRoute from '@components/routes/PrivateRoute'

// ** Utils
import { isObjEmpty } from '@utils'

const getLayout = {
  blank: <BlankLayout />,
  vertical: <VerticalLayout />,
  horizontal: <HorizontalLayout />
}

// ** Document title
const TemplateTitle = '%s - Vuexy React Admin Template'

// ** Default Route
const DefaultRoute = 'dashboardscoc/list'
//const DefaultRoute = 'closures/executive/list'

// ** Merge Routes
const Routes = [
  ...ClosuresExecutive,
  ...ClosuresManager,
  ...ClosuresCharge,
  ...ClosuresPayment,
  ...Meetings,
  ...Uptakes,
  ...Prospections,
  ...EquipmentsLoan,
  ...Equipments,
  ...AuthenticationRoutes,
  ...DashboardRoutes,
  ...AppRoutes,
  ...PagesRoutes,
  ...UiElementRoutes,
  ...ExtensionsRoutes,
  ...PageLayoutsRoutes,
  ...FormRoutes,
  ...TablesRoutes,
  ...ChartsRoutes,
  ...Calculator,
  ...Access,
  ...Comission,
  ...Publications,
  ...Attendance,
  ...Conversions,
  ...ConversionsUnitIndex,
  ...LoanKey,
  ...Kpis,
  ...KpisConfig,
  ...Offices,
  ...Feepayment,
  ...ClosuresAll,
  ...Results,
  ...ComissionMaster,
  ...ComissionMasterUni,
  ...UnifiedInvoice,
  ...DashboardsCOC,
  ...DashboardsGlobal,
  ...DashboardAsisstance
]

const getRouteMeta = route => {
  if (isObjEmpty(route.element.props)) {
    if (route.meta) {
      return { routeMeta: route.meta }
    } else {
      return {}
    }
  }
}

// ** Return Filtered Array of Routes & Paths
const MergeLayoutRoutes = (layout, defaultLayout) => {
  const LayoutRoutes = []

  if (Routes) {
    Routes.filter(route => {
      let isBlank = false
      // ** Checks if Route layout or Default layout matches current layout
      if (
        (route.meta && route.meta.layout && route.meta.layout === layout) ||
        ((route.meta === undefined || route.meta.layout === undefined) && defaultLayout === layout)
      ) {
        let RouteTag = PrivateRoute

        // ** Check for public or private route
        if (route.meta) {
          route.meta.layout === 'blank' ? (isBlank = true) : (isBlank = false)
          RouteTag = route.meta.publicRoute ? PublicRoute : PrivateRoute
        }
        if (route.element) {
          const Wrapper =
            // eslint-disable-next-line multiline-ternary
            isObjEmpty(route.element.props) && isBlank === false
              ? // eslint-disable-next-line multiline-ternary
                LayoutWrapper
              : Fragment

          route.element = (
            <Wrapper {...(isBlank === false ? getRouteMeta(route) : {})}>
              <RouteTag route={route}>{route.element}</RouteTag>
            </Wrapper>
          )
        }

        // Push route to LayoutRoutes
        LayoutRoutes.push(route)
      }
      return LayoutRoutes
    })
  }
  return LayoutRoutes
}

const getRoutes = layout => {
  const defaultLayout = layout || 'vertical'
  const layouts = ['vertical', 'horizontal', 'blank']

  const AllRoutes = []

  layouts.forEach(layoutItem => {
    const LayoutRoutes = MergeLayoutRoutes(layoutItem, defaultLayout)

    AllRoutes.push({
      path: '/',
      element: getLayout[layoutItem] || getLayout[defaultLayout],
      children: LayoutRoutes
    })
  })
  return AllRoutes
}

export { DefaultRoute, TemplateTitle, Routes, getRoutes }
